import {
  FacebookPage,
  InstagramAccount,
  IntegrationConnectionStatus,
} from "@markit/common.types";
import { Colors } from "./colors";

// Shared helpers for any connected social account (Instagram accounts, Facebook
// Pages, ...) - identical logic across platforms, just different account shapes.

// Renders an account's connection status as a dot color + label for the Connections tab.
export const getAccountConnectionStatusDisplay = (
  status: IntegrationConnectionStatus
): { label: string; color: string } => {
  switch (status) {
    case IntegrationConnectionStatus.ERROR:
      return { label: "Reconnect Needed", color: Colors.RED3 };
    case IntegrationConnectionStatus.PAUSED:
      return { label: "Paused", color: Colors.ORANGE1 };
    default:
      return { label: "Connected", color: Colors.GREEN2 };
  }
};

// An Error account is still considered connected, but needs to be resolved
export const isAccountConnected = (status: IntegrationConnectionStatus) =>
  status === IntegrationConnectionStatus.CONNECTED ||
  status === IntegrationConnectionStatus.ERROR;

// Checks if the account has at least one connected account of a given platform
export const hasSocialAccountConnection = (
  accounts: FacebookPage[] | InstagramAccount[]
) => accounts.length > 0;
